//#region IMPORT
import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
/** Services Import */
import Commons from '../../../../Services/Common/Common';
import Global from '../../../../Services/Common/Global';
/** Components */
import 'dayjs/locale/ko';
import useDelete from '../../../../hooks/useDeleteN';
import { useSearch1, useDelete1, useSave1 } from './HAM_HAN_01_QUERY';
/** Icons Import */
import HAM_HAN_01 from './HAM_HAN_01';
import usePartialRefresh from '../../../../hooks/usePartialRefresh';
import { useSave } from '../../../../hooks/useSaveN';
import useFileUpload from '../../../../hooks/useFileUpload';
import { HAM_HAN_01_Schema } from './HAM_HAN_01_Schema';
//#endregion

//#region 상수
// 화면 MENU_ID
const SCREEN_MENU_ID = 'HazardousMaterials';
//#endregion

function HAM_HAN_01F(props) {
  //#region 변수
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);
  const searchInfo = useSelector((state) => state.SearchInfo);
  const gridRef1 = useRef(); // 작업계획서

  const [rowData1, setRowData1] = useState([]); //그리드 데이터
  const [selectedRowData1, setSelectedRowData1] = useState([]);
  const [changedRowData1, setChangedRowData1] = useState([]);
  const [deletedRowData1, setDeletedRowData1] = useState([]);
  const selectedRowNosRef1 = useRef(new Set());
  const lastCheckedIndexRef1 = useRef(null);
  const currentRowIndexRef1 = useRef(null);
  //#endregion

  //#region 커스텀훅
  const { SaveLogicPreview, SaveLogicFile, DeleteLogicFile } = useFileUpload({
    oldFilePathField: 'filePath',
    newFileNameField: 'saveName',
    getTargetPath: () => {
      return `HazardousMaterials/${searchInfo.custCd}/HAM_HAN_01`;
    },
  });
  // 부분 갱신 처리 (성공한 데이터만 재조회, 실패한 데이터는 유지)
  const { handlePartialRefresh } = usePartialRefresh({
    gridRef: gridRef1,
    changedRowData: changedRowData1,
    setChangedRowData: setChangedRowData1,
    setRowData: setRowData1,
    getKeyFromRow: (row) => row.chaebun,
    getKeyFromResult: (result) => result.chaebun,
  });
  //#endregion

  //#region useEffect
  useEffect(() => {
    if (!props.searchClick1) return;
    resetLogic1();

    const { custCd, startDate, endDate } = searchInfo || {};
    if (!custCd) {
      props.setSearchClick1(false);
      return;
    }

    if (!props.validateSelection()) {
      props.setSearchClick1(false);
      return;
    }

    searchLogic1();
    props.setSearchClick1(false);
  }, [
    props.searchClick1,
    searchInfo.custCd,
    searchInfo.startDate,
    searchInfo.endDate,
  ]);

  // 버튼 로직
  useEffect(() => {
    if (props.filterClick1) {
      if (!props.validateSelection()) {
        props.setFilterClick1(false);
        return;
      }

      gridRef1.current.api &&
        gridRef1.current.api.setQuickFilter(searchInfo.searchText || '');
      props.setFilterClick1(false);
    }
    if (props.saveClick1) {
      if (!props.validateSelection()) {
        props.setSaveClick1(false);
        return;
      }

      const needGubun = changedRowData1.some((r) => !r.deleteYn && !r.gubunId);
      if (needGubun && !props.gubunId) {
        dispatch(
          showSnackbar({
            message: '구분을 선택한 후 저장하세요.',
            type: 'warning',
          })
        );
        props.setSaveClick1(false);
        return;
      }

      save1();
      props.setSaveClick1(false);
    }
  }, [props.filterClick1, props.saveClick1, searchInfo.searchText]);
  //#endregion

  //#region 쿼리
  // 조회
  const { refetch: search1 } = useSearch1({
    gubunId: props.gubunId,
    onSuccess: (rows) => {
      setRowData1(rows);
    },
  });
  const searchLogic1 = async () => {
    resetLogic1();
    await search1();
  };

  // 삭제
  const delete1 = useDelete1();
  const deleteHandler1 = useDelete({
    gridRef: gridRef1,
    deleteMutation: delete1,
    updateDeleted: setDeletedRowData1,
    updateRowData: setRowData1,
    deletedRowData: deletedRowData1,
    rowData: rowData1,
    setChangedRowData: setChangedRowData1,
  });

  // 저장
  const { runAsync: save1Async } = useSave1();
  const { run: save1 } = useSave({
    menuId: SCREEN_MENU_ID,
    requiredLabel: '파일 업로드',
    schema: HAM_HAN_01_Schema,
    getChangedRows: () => changedRowData1.filter((r) => !r.deleteYn),
    getDeletedRows: () => deletedRowData1,
    requestDelete: deleteHandler1.DeleteLogic,
    requestSave: (rows) =>
      save1Async(
        rows.map((r) => ({ ...r, gubunId: r.gubunId || props.gubunId }))
      ),
    fileSave: SaveLogicFile,
    fileDelete: DeleteLogicFile,
    refresh: () => searchLogic1(),
    reset: () => resetLogic1(),
    partialRefresh: async ({ saveResult, changedRows }) => {
      await handlePartialRefresh({
        saveResult,
        changedRows,
        searchLogic: searchLogic1,
      });
    },
  });

  // 초기화
  const resetLogic1 = () => {
    setRowData1([]);
    setSelectedRowData1([]);
    setChangedRowData1([]);
    setDeletedRowData1([]);
    gridRef1?.current?.api?.deselectAll();
  };
  //#endregion

  //#region 나머지 함수
  // 파일 다운로드
  const downloadLogic2 = async (_data) => {
    if (_data.newYn === 'Y') {
      dispatch(
        showSnackbar({
          message: '저장 후 파일 다운로드가 가능합니다.',
          type: 'warning',
        })
      );
      return;
    }

    if (!_data.filePath) {
      dispatch(
        showSnackbar({ message: '파일이 존재하지 않습니다.', type: 'warning' })
      );
      return;
    }

    try {
      const filePath = fixUrl(_data.filePath);
      const fileName = _data.fileName || 'downloaded_file';

      const params = {
        FileName: fileName,
        Url: filePath,
      };

      await Commons.Axios(
        'fileDown',
        Global.file.useUrl + Global.urls.Execute.UrlFileDownload,
        params
      ).then((result) => {
        const contentType = result?.headers?.['content-type'];
        const blobData = result?.data;

        if (!blobData || !contentType) {
          dispatch(
            showSnackbar({
              message: `"${fileName}" 다운로드 응답이 비정상입니다.`,
              type: 'error',
            })
          );
          return;
        }

        // 1) Blob → Object URL 생성
        const blob = new Blob([blobData], { type: contentType });
        const url = window.URL.createObjectURL(blob);

        // 2) <a> 태그 만들어서 클릭 트리거
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName; // 저장될 파일명
        document.body.appendChild(a);
        a.click();

        // 3) 정리
        a.remove();
        window.URL.revokeObjectURL(url);

        dispatch(
          showSnackbar({
            message: `"${fileName}" 다운로드 완료`,
            type: 'success',
          })
        );
      });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    }
  };

  const newYnErrorMsg = () => {
    dispatch(
      showSnackbar({
        message: '데이터 입력중입니다. 저장 후 시도하세요.',
        type: 'warning',
      })
    );
  };

  const handleRowSelection1 = (rowData, rowIndex) => {
    currentRowIndexRef1.current = rowIndex;
    setSelectedRowData1([rowData]);
  };

  const fixUrl = (url) => {
    if (!url || typeof url !== 'string') return ''; // 또는 적절한 fallback
    const parts = url.split('/');
    const fileName = parts.pop(); // 파일 이름 분리
    const encodedFileName = encodeURIComponent(fileName);
    return [...parts, encodedFileName].join('/');
  };
  //#endregion

  return (
    <div className="wrap">
      <HAM_HAN_01
        gridId1={'grid1'}
        navigate={navigate}
        userInfo={userInfo}
        rowData1={rowData1}
        lanInfo={lanInfo}
        gridRef1={gridRef1}
        setRowData1={setRowData1}
        selectedRowData1={selectedRowData1}
        setSelectedRowData1={setSelectedRowData1}
        changedRowData1={changedRowData1}
        setChangedRowData1={setChangedRowData1}
        selectedRowNosRef1={selectedRowNosRef1}
        deletedRowData1={deletedRowData1}
        lastCheckedIndexRef1={lastCheckedIndexRef1}
        dispatch={dispatch}
        showSnackbar={showSnackbar}
        // 함수
        validateSelection={props.validateSelection}
        gubunId={props.gubunId}
        searchLogic1={searchLogic1}
        SaveLogicPreview={SaveLogicPreview}
        downloadLogic2={downloadLogic2}
        newYnErrorMsg={newYnErrorMsg}
        handleRowSelection1={handleRowSelection1}
        restoreRow1={deleteHandler1.RestoreRow}
        markedForDeletion1={deleteHandler1.MarkedForDeletion}
        deleteNewRow1={deleteHandler1.DeleteNewRow}
      />
    </div>
  );
}

export default HAM_HAN_01F;
